import type {PinListItem} from '../../types';

import {dateToReadableDate} from '@date-picker';
import {Chip, Loading} from '@ds/components';
import {getStatusChipProps} from 'common/status-chip/getStatusChipProps';
import InfiniteScroll from 'react-infinite-scroll-component';
import {useNavigate} from 'react-router-dom';

import {PIN_ROUTES, PIN_STATE_LABELS} from '../../../constants';

type PinHistoryListProps = {
  pins: PinListItem[];
};

const PinHistoryList: React.FC<PinHistoryListProps> = ({pins}) => {
  const navigate = useNavigate();

  return (
    <InfiniteScroll
      dataLength={pins.length}
      scrollableTarget="pin-list"
      next={() => undefined}
      hasMore={false}
      loader={
        <div className="flex h-10 justify-center">
          <Loading size="medium" color="primary" />
        </div>
      }
      scrollThreshold={0.6}
    >
      <div className="flex flex-col">
        {pins.map((pin) => {
          const state = pin.state ?? '';
          const chipProps = getStatusChipProps(state);

          return (
            <button
              type="button"
              key={pin.id}
              className="flex w-full items-center justify-between gap-3 border-b border-gray-03 px-4 py-3 text-start focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange"
              onClick={() => navigate(PIN_ROUTES.details.replace(':pinId', String(pin.id)))}
            >
              <span className="flex min-w-0 flex-1 flex-col">
                <span className="text-body-sm-emphasis text-neutral-fg">
                  {dateToReadableDate({
                    date: pin.activate_date ?? '',
                    month: true,
                    day: true
                  })}
                </span>
                <span className="text-body-sm text-gray-07">{pin.region_name}</span>
              </span>
              <Chip
                label={PIN_STATE_LABELS[state] ?? state}
                variant={chipProps.variant}
                color={chipProps.color}
                size="sm"
                interactive={false}
              />
            </button>
          );
        })}
      </div>
    </InfiniteScroll>
  );
};

export default PinHistoryList;
